exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spell-icon[data-v-2da1d22b]{border-width:1px;--tw-border-opacity:1;border-color:rgb(19 19 19/var(--tw-border-opacity));margin-right:.5rem;width:70px;height:70px;background-repeat:no-repeat;background-size:cover;background-position:50%;box-shadow:inset 0 0 0 3px #131313;filter:grayscale(100%)}.spell-icon--selected[data-v-2da1d22b]{--tw-border-opacity:1;border-color:rgb(247 183 51/var(--tw-border-opacity));filter:none}", ""]);

// exports
